import classnames from 'classnames';
import React, { ReactNode } from 'react';

const CSS = require('./SectionTitle.module.scss');

interface SectionTitleProps {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  variant?: 'default' | 'dark-green' | 'sandstone' | 'black';
  alignment?: 'left' | 'center' | 'center-sm' | 'right';
  weight?: 'semi-bold' | 'bold';
  className?: any;
  children: ReactNode | string;
}

function SectionTitle({
  as: Component = 'h2',
  variant = 'default',
  alignment = 'left',
  weight = 'semi-bold',
  className,
  children,
}: SectionTitleProps) {
  const classes = classnames(CSS.SectionTitle, {
    [CSS.VariantDarkGreen]: variant === 'dark-green',
    [CSS.VariantSandstone]: variant === 'sandstone',
    [CSS.VariantBlack]: variant === 'black',
    [CSS.AlignmentCenter]: alignment === 'center',
    [CSS.AlignmentCenterSM]: alignment === 'center-sm',
    [CSS.AlignmentCenterRight]: alignment === 'right',
    [CSS.WeightBold]: weight === 'bold',
    [className]: !!className,
  });
  return <Component className={classes}>{children}</Component>;
}

export default SectionTitle;
